import { render } from "./page-acces-token.vue?vue&type=template&id=41da08b4"
import script from "./page-acces-token.vue?vue&type=script&lang=js"
export * from "./page-acces-token.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__